import { ActionDispatching } from 'app/types-shared';
import { ErrorNotification } from 'app/infrastructure/notifications/user-messages';
import {
  RequestMetadata, ReceiveMetadata, FailMetadata, RequestAccessCodetables, ReceiveAccessCodetables,
  FailAccessCodetables, RequestCodeItemAccessCodes, ReceiveCodeItemAccessCodes, FailCodeItemAccessCodes,
  ClearCodetablesAccess
} from './action-types';
import { api } from './api';
import { isForbiddenStatus, blockAccess, isNotAcceptable } from 'app/area/shared/actions-utils';
import { STATE } from 'app/constants';
import { codetableAdministrationTranslation as text } from './constants';
import { mapMetadataToStore } from 'app/area/codetable/mappers/map-metadata-to-store';
import { CodetableSelectorProps } from 'app/area/codetable/types';
import { ApplicationState } from 'app/types-store';
import { getCodetableId } from 'app/area/shared/codetable/breadcrumbs';
import { mapCodeItemAccess } from 'app/area/codetable/item/mapping/map-code-item';
import { AccessCodetables, CodetableAdministrationState } from 'app/area/codetable/types-store';
import { canLoadCodesAccess } from 'app/area/codetable/item/codetable-item-helpers';

export const actionCreators = {

  loadMetadata: (id: number): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestMetadata(id));

      if (id as unknown as string === '') {

        dispatch(new FailMetadata(id));
        blockAccess({
          dispatch,
          getState,
          area: STATE.administrationCodetable,
          translationId: text.no_codetable
        });

        return;
      }

      try {
        const metadataWire = await api.loadMetadata(id);

        const metadata = mapMetadataToStore(metadataWire);

        dispatch(new ReceiveMetadata(id, metadata));

      } catch (err) {
        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.administrationCodetable,
            translationId: text.no_access_to_codetable_administration
          });
        } else if (isNotAcceptable(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.administrationCodetable,
            translationId: text.no_codetable
          });
        } else if (err && (err.userMessages || err.message)) {
          const error = err && (err.userMessages || err.message);
          error && dispatch(new ErrorNotification(error));
        }

        dispatch(new FailMetadata(id));
      }
    },

  loadCodetablesAccess: (codetableId: number): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestAccessCodetables(codetableId));

      try {
        const result = await api.loadCodetablesAccess(codetableId);
        const codetablesAccess = (result && result.length > 0) ? result.find(f => f.id === codetableId) : {} as AccessCodetables;

        if (!codetablesAccess) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.administrationCodetable,
            translationId: text.no_access_to_codetable_administration
          });
        }

        dispatch(new ReceiveAccessCodetables(codetableId, codetablesAccess));
      } catch (err) {
        blockAccess({
          dispatch,
          getState,
          area: STATE.administrationCodetable,
          translationId: text.no_access_to_codetable_administration
        });
        dispatch(new FailAccessCodetables(codetableId));
      }
    },

  loadCodesAccess: (props: CodetableSelectorProps & CodetableAdministrationState): ActionDispatching<any, any> =>
    async (dispatch: any, getState: () => ApplicationState) => {
      const { codeId, breadcrumbs, access: { data: { codetables: accessCodetables } = {} } = {} } = props;
      const codetableId = getCodetableId(breadcrumbs);

      const canLoad = canLoadCodesAccess({
        canCreate: accessCodetables.create,
        administrationCentral: accessCodetables.administrationCentral
      });

      dispatch(new RequestCodeItemAccessCodes(codetableId, codeId));

      try {
        const result = !canLoad ? await api.loadCodesAccess(codetableId, codeId) : [];
        const mappedCodesAccess = mapCodeItemAccess(codeId, result);

        dispatch(new ReceiveCodeItemAccessCodes(mappedCodesAccess));

      } catch (err) {
        blockAccess({
          dispatch,
          getState,
          area: STATE.administrationCodetable,
          translationId: text.no_codetable
        });
        dispatch(new FailCodeItemAccessCodes(codetableId, codeId));
      }
    },

  clearCodetablesAccess: () => (dispatch: any, getState: any) => {
    dispatch(new ClearCodetablesAccess());
  }
};
